import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profiles: [],
  active: null,
};

const panelsDynamicProfilesSlice = createSlice({
  name: 'panelsDynamicProfiles',
  initialState,
  reducers: {
    panelsDynamicProfilesLoad: (state, action) => {
      state.profiles = action.payload;
      state.active = null;
    },

    panelsDynamicProfilesActive: (state, action) => {
      state.active = { ...action.payload };
    },

    panelsDynamicProfilesUpdate: (state, action) => {
      state.active = {
        ...state.active,
        ...action.payload,
      };
    },

    panelsDynamicProfilesRemoveActive: (state) => {
      state.active = null;
    },

    panelsDynamicProfilesLogoutCleaning: () => initialState,
  },
});

export const {
  panelsDynamicProfilesLoad,
  panelsDynamicProfilesActive,
  panelsDynamicProfilesUpdate,
  panelsDynamicProfilesRemoveActive,
  panelsDynamicProfilesLogoutCleaning,
} = panelsDynamicProfilesSlice.actions;

export default panelsDynamicProfilesSlice.reducer;